import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./SubscribedMap.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { ISubscribedMap } from "./ISubscribed";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import SubscribedMapForm from "./SubscribedMapForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { clearAddSubscribedMapResponse } from "../../Redux/Slices/SubscribedMap/AddSubscribedMapSlice";
import {
  clearDeleteSubscribedMapResponse,
  deleteSubscribedMap,
} from "../../Redux/Slices/SubscribedMap/DeleteSubscribedMapSlice";
import { clearEditSubscribedMapResponse } from "../../Redux/Slices/SubscribedMap/EditSubscribedMapSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listPackage } from "../../Redux/Slices/Package/ListPackageSlice";
import { listUserAdmin } from "../../Redux/Slices/UserAdmin/ListUserAdminSlice";
import { listSubscribedMap } from "../../Redux/Slices/SubscribedMap/ListSubscribedMapSlice";

interface SubscribedMapProps {}

const SubscribedMap: FunctionComponent<SubscribedMapProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<ISubscribedMap | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listSubscribedMaps } = useAppSelector(
    (state) => state.ListSubscribedMapSlice
  );
  const { data: addSubscribedMap } = useAppSelector(
    (state) => state.AddSubscribedMapSlice
  );
  const { data: EditSubscribedMap } = useAppSelector(
    (state) => state.EditSubscribedMapSlice
  );
  const { data: deleteSubscribedMaps } = useAppSelector(
    (state) => state.DeleteSubscribedMap
  );

  // user permisssion
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission
  );

  const to = "settings";

  const filteredList = userPermissionlist.Dashboard.filter(
    (item: any) => item.to === to
  );
  const fliterdata: any = filteredList[0]?.items;
  const finaldata = fliterdata[0];

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "package_name",
      renderHeader: () => <b>Package Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "user_name",
      renderHeader: () => <b>Student Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "subscribed_on",
      headerName: "Subscribed On",
      renderHeader: () => <b>Subscribed On</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params) => {
        const date = new Date(params.value);
        const formatted = date.toLocaleDateString("en-GB"); // Outputs DD/MM/YYYY
        // Replace slashes with dashes
        return formatted.replace(/\//g, "-");
      },
    },
    {
      field: "end_date",
      headerName: "End Date",
      renderHeader: () => <b>End Date</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params) => {
        const date = new Date(params.value);
        const formatted = date.toLocaleDateString("en-GB"); // Outputs DD/MM/YYYY
        // Replace slashes with dashes
        return formatted.replace(/\//g, "-");
      },
    },

    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<ISubscribedMap>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row });
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const SubscribedMap = Array.isArray(listSubscribedMaps?.data)
    ? listSubscribedMaps?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];

  useEffect(() => {
    dispatch(listSubscribedMap());
    dispatch(listPackage());
    dispatch(
      listUserAdmin({
        rolename: "STUDENT",
      })
    );
    // dispatch(listSideMenuPermission());
  }, [addSubscribedMap, EditSubscribedMap, deleteSubscribedMaps, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddSubscribedMapResponse());
      dispatch(clearEditSubscribedMapResponse());
      dispatch(clearDeleteSubscribedMapResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={SubscribedMap ?? []} columns={columns}>
        <CustomToolbar>
          {/* <h6>Assign Package</h6> */}
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => setDialogOpen(true)}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listSubscribedMap())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog"
        Dialog_Title={`${
          (initialValues as ISubscribedMap).id ? "Update" : "Add"
        } Assign Package`}
        dialogContentClassName="dialog_content"
        Dialog_Content={
          <SubscribedMapForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog
        response={addSubscribedMap}
        parentDialog={setDialogOpen}
      />
      <ResponseDialog
        response={EditSubscribedMap}
        parentDialog={setDialogOpen}
      />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteSubscribedMap(deleteDialogData.id));
        }}
        response={deleteSubscribedMaps}
      />
    </>
  );
};

export default SubscribedMap;
